'use strict';

icing.watch('[data-sortable]', container => {
    import(/* webpackChunkName: 'dragula' */ 'sortablejs')
        .then(({default: Sortable}) => {
            window.Sortable = Sortable;

            const options = {
                animation: 100,
                onSort: (e) => {
                    e.to.querySelectorAll('[data-sortable-order]')
                        .forEach((input, index) => {
                            input.value = index;
                        });

                    if (e.from !== e.to) {
                        e.from.querySelectorAll('[data-sortable-order]')
                            .forEach((input, index) => {
                                input.value = index;
                            });
                    }
                }
            };

            if (container.dataset.sortable) {
                try {
                    Object.assign(options, JSON.parse(container.dataset.sortable));
                } catch (e) {
                    Object.assign(options, {group: container.dataset.sortable});
                }
            }

            const form = container.closest('form');
            if (form) {
                form.addEventListener('submit', () => {
                    container.querySelectorAll('[data-sortable-order]')
                        .forEach((input, index) => {
                            input.value = index;
                            input.dispatchEvent(new Event('change', { bubbles: true }));
                        });
                });
            }

            new window.Sortable(container, options);
        })
        .catch(console.warn);
})
